import React from "react";
import { observer } from "mobx-react";
import { Button, Stack, Text } from "@chakra-ui/react";
import { translations } from "@/constants/translations";
import { useStore } from "@/store";
import { renderInnerHtml } from "@/helpers/dom";
import { useAppNavigate } from "@/routing/useAppNavigate";
import { H2, H3 } from "@/components/Heading";
import { useEffectOnce } from "usehooks-ts";
import { telemetry } from "@/telemetry";
import { getSecondsSinceTermsViewed } from "../helpers";

export const RegisterConfirmPage = observer(() => {
  const { activeLanguage, registerData } = useStore();
  const language = translations.pages["register-thankyou"][activeLanguage];

  useEffectOnce(() =>
    telemetry.trackEvent("registration_completed", {
      seconds_since_terms: getSecondsSinceTermsViewed(),
    }),
  );

  const navigate = useAppNavigate();

  const handleRedirect = () => {
    navigate({
      to: "/order/details",
    });
  };

  return (
    <Stack
      spacing="14"
      alignItems="center"
      textAlign="center"
    >
      <H2>{language.thank_submitting_registration}</H2>
      <H3>
        {language.a_member_emergent_email}
        <Text
          as="span"
          color="primary-light"
        >
          {registerData.billingContactEmail}
        </Text>
        {language.when_registration_approved}
      </H3>
      <H3>{renderInnerHtml(language.please_click)}</H3>
      <Text>{language.prior_approval}</Text>
      <Button onClick={handleRedirect}>
        {renderInnerHtml(language.place_order)}
      </Button>
    </Stack>
  );
});
